<template>
    <div
        class="h-100 position-relative gallery-root d-flex flex-column justify-center"
        @click="close"
        :class="{ init }"
    >
        <v-btn
            id="close-gallery"
            :icon="mdiClose"
            variant="tonal"
            size="small"
            color="cis-accent-color"
            @click="close"
        >
        </v-btn>
        <div class="main-swiper d-flex mb-4">
            <swiper
                :modules="[Thumbs, EffectFade, Navigation, Keyboard]"
                :thumbs="{ swiper: swiperThumbs, multipleActiveThumbs: false, autoScrollOffset: 1 }"
                :navigation="{
                    nextEl: '#gallery-next',
                    prevEl: '#gallery-prev',
                }"
                class="flex-fill align-self-stretch"
                effect="fade"
                :keyboard="{
                    enabled: true,
                }"
                :auto-height="true"
                :fade-effect="{ crossFade: true }"
                :initial-slide="index"
                @swiper="swiperMain = $event"
            >
                <swiper-slide
                    v-for="media in images"
                    :key="media.id"
                    class="text-center align-center justify-center d-flex c-slide"
                >
                    <img
                        :src="media.url"
                        :alt="media.alt"
                        class="main-image"
                        style="min-height: 40px; max-width: 100%"
                    />
                </swiper-slide>
                <template v-if="$vuetify.display.mdAndUp" v-slot:wrapper-end>
                    <div id="gallery-prev" class="swiper-button-prev" @click.stop></div>
                    <div id="gallery-next" class="swiper-button-next" @click.stop></div>
                </template>
            </swiper>
        </div>
        <div class="thumbs-gallery d-flex">
            <swiper
                :modules="[Thumbs]"
                :space-between="10"
                :initial-slide="index"
                slides-per-view="auto"
                watch-slides-progress
                watch-overflow
                free-mode
                observer
                observe-slide-children
                @swiper="swiperThumbs = $event"
            >
                <swiper-slide v-for="media in images" :key="media.id">
                    <v-img
                        height="70"
                        width="auto"
                        max-width="150"
                        cover
                        :src="media.url"
                        :alt="media.alt"
                        @click.stop
                        @load="swiperThumbs?.update()"
                    />
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Thumbs, EffectFade, Navigation, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/thumbs';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import { ref, watch } from 'vue';
import { mdiClose } from '@mdi/js';


const emit = defineEmits(['close']);
const props = defineProps({
    images: Array,
    index: [Number, String],
});
const swiperMain = ref(null);
const swiperThumbs = ref(null);
const init = ref(false);
const close = () => {
    init.value = false;
    emit('close');
};

watch(swiperMain, () => {
    init.value = true;
});
</script>

<style scoped lang="scss">
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';

#close-gallery {
    position: absolute;
    right: $spacer * 4;
    top: $spacer * 4;
    z-index: 2;
}

:deep(.main-swiper) {
    max-height: 80dvh;
    > .swiper {
        max-height: inherit;
        > .swiper-wrapper {
            max-height: inherit;
            height: 100% !important;
            align-items: center;
            > .swiper-slide {
                max-height: inherit;
            }
        }
    }
    img {
        max-height: inherit;
        height: auto;
        max-width: 100%;
        width: auto;
    }
}

:deep(.thumbs-gallery) {
    .swiper-slide {
        border: 3px solid transparent;
        &.swiper-slide-thumb-active {
            border-color: rgb(var(--v-theme-cis-accent-color));
        }
    }
}

.gallery-root {
    transform: scale(0.7);
    opacity: 0;
    transition:
        opacity 0.8s ease-in-out,
        transform 0.8s ease-in-out;

    &.init {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
